import { WarningCircleIcon } from '@phosphor-icons/react';
import { T, Var } from 'gt-react';
import { SpaRecordLinks } from './SpaDunsCheck';
import type { SpaDunsComparison } from './spaDunsComparison';

/**
 * On a staged 844: the DUNS it would be sent with is not a branch any SPA
 * active on its invoice date names, so the supplier will reject it as
 * contract-ineligible (AAA code 1). Shows the DUNS the active SPAs do name,
 * each linked to its SPA record.
 */
export function SpaDunsWarning({ mismatch }: { mismatch: SpaDunsComparison }) {
  const { submitted, asOf, spaCodes, activeSpas } = mismatch;
  return (
    <div
      role="alert"
      className="rounded-lg border border-red-200 bg-red-50/60 px-3 py-2 text-red-800"
    >
      <p className="flex items-start gap-1.5 text-sm font-medium">
        <WarningCircleIcon className="h-4 w-4 mt-0.5 shrink-0" />
        {asOf ? (
          <T context="staged 844 warning: the claim's DUNS is not on any SPA active on its invoice date">
            DUNS <Var>{submitted}</Var> is not on any SPA active on{' '}
            <Var>{asOf}</Var>. The SPA names <Var>{spaCodes.join(', ')}</Var>.
          </T>
        ) : (
          <T context="staged 844 warning: the claim's DUNS is not on any SPA on file (claim has no invoice date)">
            DUNS <Var>{submitted}</Var> is not on any SPA on file. The SPA names{' '}
            <Var>{spaCodes.join(', ')}</Var>.
          </T>
        )}
      </p>
      <p className="mt-0.5 pl-5 text-xs">
        <T context="staged 844 warning: consequence of sending a DUNS the SPA does not name">
          The supplier will likely reject this claim as contract-ineligible
          (code 1).
        </T>
      </p>
      <div className="pl-5">
        <SpaRecordLinks spas={activeSpas} />
      </div>
    </div>
  );
}
